import popMgr from '../global/popMgr';
import signLog from '../sign-log';
import { isAgent } from '@/common/const.js'
const templateMap = {
    template1: 'classic',
    template2: 'classic',
    standard: 'standard',
    template4: 'fashion'
};

let ps = () => import('./component.vue');

const snapshotPop = {
    prepare(theme) {
        if (!theme) {
            const template = window.sitePrepareData().template;
            theme = templateMap[template] || 'classic';
        }
        return ps().then(f => f.default);
    },

    open(theme, options = {}) {
        theme = theme || templateMap[window.sitePrepareData().template];
        options.theme = theme;
        if (popMgr.currentPops.some(pop => pop.name === 'saveSnapshot')) {
            return;
        }
        if (!isAgent(options?.data?.roles) && !options?.data?.isRegisterAgentLead) {
            this.prepare(theme).then(config => {
                popMgr.create(
                    config,
                    {
                        name: 'saveSnapshot',
                        theme,
                        options
                    },
                    'hideOtherPop'
                );
            });
        }
        
    },

    openAfterRegister(theme, options) {
        signLog.register({
            languageTextFn: {
                registerTitle: _ =>
                    window.siteGlobalization.$t('common:signLog.saveMarketSnapshot'),
                registerSubTitle: _ =>
                    window.siteGlobalization.$t('common:signLog.provideYourContact'),
                ...(options.languageTextFn || {})
            },
            onsuccess: (data) => {
                this.open(theme, { ... options, data });
                return false;
            }
        });
    }
};

export default snapshotPop;
